import { render } from "./CabeceraComponent.vue?vue&type=template&id=6c78493e&scoped=true"
import script from "./CabeceraComponent.vue?vue&type=script&lang=js"
export * from "./CabeceraComponent.vue?vue&type=script&lang=js"

import "./CabeceraComponent.vue?vue&type=style&index=0&id=6c78493e&scoped=true&lang=css"

import exportComponent from "C:\\trabajo_espacio\\cuadros.ges.com\\com.ges.cuadros\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c78493e"]])

export default __exports__